import { applyConfigPersonContentTypeValidation } from './personContentType';

const applyConfigCustomValidations = (config) => {
  applyConfigPersonContentTypeValidation(config);

  return config;
};

export default applyConfigCustomValidations;
